<template>
  <gg-card>
    <gg-card-header>
      {{ alert.alert_title }}
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12" sm="3">
          <div>{{ alert.service }}</div>
          <div>Current usage - {{ alert.currentUsage }}</div>
          <div>Alert Threshold - {{ alert.alertThreshold }}</div>
          <div>Created: {{ alert.created_at }}</div>
          <div>Last Notified: {{ alert.last_notified_at }}</div>
          <div v-if="alert.subaccount_username">cPanel Username: {{ alert.subaccount_username }}</div>
        </v-col>
        <v-col cols="12" sm="3">
          {{ alert.alert_description }}
        </v-col>
        <v-col cols="12" sm="3" class="text-capitalize text-center">
          <v-icon small class="mb-1" :color="statusColor(alert.status)">
            mdi-circle
          </v-icon>
          {{ alert.status }}
        </v-col>
        <v-col v-if="viewDetails" cols="12" sm="3">
          <gg-btn :to="`/alerts/${alert.id}`">View Details</gg-btn>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AlertItem',
  props: {
    alert: {
      required: true,
      type: Object
    },
    viewDetails: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    ...mapActions(['navigateTo']),
    statusColor (status) {
      switch (status) {
        case 'pending':
          return 'orange'
        case 'active':
          return 'red'
        case 'Needs Resolution':
          return 'red'
        case 'resolved':
          return 'green'
        case 'closed':
          return 'grey'
        default:
          return 'grey'
      }
    }
  }
}
</script>
